import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    if (!/\d/.test(password)) {
      setError('Password must contain at least 1 number');
      return;
    }

    setLoading(true);

    try {
      await api.request('/auth/reset-password', {
        method: 'POST',
        body: JSON.stringify({ token, newPassword: password })
      });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-100">
        <div className="w-full max-w-sm">
          <div className="bg-white border border-neutral-200 p-6">
            <h1 className="text-lg font-medium text-red-600 mb-4">Invalid Link</h1>
            <p className="text-sm text-neutral-600 mb-4">
              This password reset link is invalid or has expired.
            </p>
            <Link to="/forgot-password" className="text-sm text-blue-600 hover:underline">
              Request a new reset link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-100">
        <div className="w-full max-w-sm">
          <div className="bg-white border border-neutral-200 p-6">
            <h1 className="text-lg font-medium text-green-600 mb-4">Password Reset!</h1>
            <p className="text-sm text-neutral-600 mb-4">
              Your password has been reset successfully. Redirecting to login...
            </p>
            <Link to="/login" className="text-sm text-blue-600 hover:underline">
              Go to login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100">
      <div className="w-full max-w-sm">
        <div className="bg-white border border-neutral-200 p-6">
          <h1 className="text-lg font-medium text-neutral-800 mb-2">Reset Password</h1>
          <p className="text-sm text-neutral-600 mb-6">
            Enter your new password below.
          </p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-neutral-600 mb-1">New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-9 px-3 text-sm border border-neutral-300 focus:border-neutral-500"
                placeholder="Min 8 chars, 1 number"
                required
              />
            </div>
            <div>
              <label className="block text-sm text-neutral-600 mb-1">Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full h-9 px-3 text-sm border border-neutral-300 focus:border-neutral-500"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full h-9 bg-neutral-800 text-white text-sm hover:bg-neutral-700 disabled:opacity-50"
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
